import { useQuery, useQueryClient } from "react-query";

const useBPAREGSearch = (tenantId, applicationType, filters, limit, departement, params, config = {}) => {
  const client = useQueryClient();

  if (["FORM_11", "FORM_26", "FORM_CLU", "FORM_NOC", "FORM_MT", "FORM_16"].includes(applicationType)) {
    return {
      ...useQuery(
        ["BPA_REG_SEARCH", tenantId, applicationType, filters, limit, departement],
        () => Digit.OBPSService.BPASearchMyApplicationForm11(tenantId, applicationType, filters, limit, departement, params),
        config
      ),
      revalidate: () => client.removeQueries(["BPA_REG_SEARCH", tenantId, filters]),
    };
  }
  if (applicationType === "FORM_MAP") {
    return {
      ...useQuery(
        ["BPA_REG_SEARCH", tenantId, applicationType, filters, limit],
        () => Digit.OBPSService.BPASearchMyApplicationForm12(tenantId, applicationType, filters, limit, params),
        config
      ),
      revalidate: () => client.removeQueries(["BPA_REG_SEARCH", tenantId, filters]),
    };
  }
  if (applicationType === "FORM_PLINTH") {
    return {
      ...useQuery(
        ["BPA_REG_SEARCH", tenantId, applicationType, filters, limit],
        () => Digit.OBPSService.BPASearchMyApplicationForm12(tenantId, applicationType, filters, limit, params),
        config
      ),
      revalidate: () => client.removeQueries(["BPA_REG_SEARCH", tenantId, filters]),
    };
  }
  if (applicationType === "FORM_FAR") {
    return {
      ...useQuery(
        ["BPA_REG_SEARCH", tenantId, applicationType, filters, limit],
        () => Digit.OBPSService.BPASearchMyApplicationForm12(tenantId, applicationType, filters, limit, params),
        config
      ),
      revalidate: () => client.removeQueries(["BPA_REG_SEARCH", tenantId, filters]),
    };
  }

  if (applicationType === "FORM_LANDUSE") {
    return {
      ...useQuery(
        ["BPA_REG_SEARCH", tenantId, applicationType, filters, limit],
        () => Digit.OBPSService.BPASearchMyApplicationFormLandUse(tenantId, applicationType, filters, limit, params),
        config
      ),
      revalidate: () => client.removeQueries(["BPA_REG_SEARCH", tenantId, filters]),
    };
  }
  return {
    ...useQuery(["BPA_REG_SEARCH", tenantId, filters], () => Digit.OBPSService.BPAREGSearch(tenantId, filters, params), config),
    revalidate: () => client.removeQueries(["BPA_REG_SEARCH", tenantId, filters]),
  };
};

export default useBPAREGSearch;
